import { formatDateTime } from "../../helper/formatCurrency";

export const generateHtmlReport = ({
  event,
  stats,
  acceptedGuests,
  declinedGuests,
  refunds,
  formatCurrency,
  formatDate,
  formatDateWithOrdinal,
  getEventStatus,
  totalRevenue,
  totalCashGifts,
  totalEventAttire,
  totalTickets,
  pendingRefundAmount,
  approvedRefundAmount,
  currentDate = new Date().toLocaleDateString(),
  responseStatus,
  usherStats,
}) => {

  const validUshers = Array.isArray(usherStats)
    ? usherStats.filter(
        (u) =>
          u&&
          (u.firstName ||
            u.lastName ||
            u.email)
      )
    : [];

  const validRefunds = Array.isArray(refunds)
    ? refunds.filter((r) => {
        const guest = r?.guestDetails;
        const hasGuestInfo =
          guest &&
          (guest.firstName ||
            guest.lastName ||
            guest.email ||
            guest.phoneNumber);

        const hasAmount =
          Array.isArray(r?.refundDetails) &&
          r.eventAttire.some((item) => (item.totalAmountToRefund || 0) > 0);

        return hasGuestInfo || hasAmount;
      })
    : [];

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Event Management Report - ${
        event?.eventTitle || "Untitled Event"
      }</title>
      <meta charset="UTF-8">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body { 
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          margin: 20px;
          line-height: 1.4;
          color: #333;
        }
        
        .header { 
          text-align: center; 
          margin-bottom: 40px;
          border-bottom: 3px solid #0e6a36;
          padding-bottom: 20px;
        }
        
        .header h1 {
          color: #0e6a36;
          font-size: 28px;
          margin-bottom: 10px;
        }
        
        .header p {
          color: #666;
          font-size: 14px;
        }
        
        .stats-container {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 30px;
        }
        
        .stats { 
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 20px;
        }
        
        .stat-box { 
          text-align: center; 
          padding: 20px; 
          background: white;
          border: 1px solid #e0e0e0; 
          border-radius: 8px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .stat-box h3 {
          color: #0e6a36;
          font-size: 14px;
          margin-bottom: 10px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .stat-box p {
          font-size: 24px;
          font-weight: bold;
          color: #333;
        }
        
        .section { 
          margin-bottom: 50px;
          break-inside: avoid;
        }
        
        .section-title { 
          font-size: 20px; 
          font-weight: bold; 
          margin-bottom: 20px; 
          color: #0e6a36; 
          border-bottom: 2px solid #0e6a36; 
          padding-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .about-event { 
          background: #f8f9fa;
          padding: 25px; 
          border: 1px solid #e0e0e0; 
          border-radius: 8px;
          margin-bottom: 20px;
        }
        
        .about-event h3 {
          color: #0e6a36;
          font-size: 22px;
          margin-bottom: 20px;
        }
        
        .event-details { 
          display: grid; 
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); 
          gap: 15px; 
          margin-bottom: 20px;
        }
        
        .event-detail-item { 
          padding: 12px 15px; 
          background: white; 
          border-radius: 6px;
          border-left: 4px solid #0e6a36;
        }
        
        .event-detail-label { 
          font-weight: bold; 
          color: #495057;
          display: block;
          margin-bottom: 4px;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .event-detail-value {
          color: #333;
          font-size: 14px;
        }
        
        .event-description {
          background: white;
          padding: 15px;
          border-radius: 6px;
          border-left: 4px solid #0e6a36;
        }
        
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin-top: 20px;
          background: white;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          border-radius: 8px;
          overflow: hidden;
        }
        
        th, td { 
          padding: 12px 15px; 
          text-align: left;
          border-bottom: 1px solid #e0e0e0;
        }
        
        th { 
          background: #0e6a36; 
          color: white;
          font-weight: 600;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        tr:nth-child(even) {
          background: #f8f9fa;
        }
        
        tr:hover {
          background: #e3f2fd;
        }
        
        .status-badge { 
          padding: 6px 12px; 
          border-radius: 20px; 
          font-size: 11px;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .status-pending { background: #fff3cd; color: #856404; }
        .status-approved { background: #d4edda; color: #155724; }
        .status-paid { background: #d1ecf1; color: #0c5460; }
        .status-declined { background: #f8d7da; color: #721c24; }
        
        .no-data {
          text-align: center;
          color: #666;
          font-style: italic;
          padding: 40px;
        }
        
        .currency {
          font-weight: 600;
          color: #0e6a36;
        }

        .financial-summary {
          background: #e8f5e8;
          padding: 20px;
          border-radius: 8px;
          margin-bottom: 20px;
        }

        .financial-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 15px;
        }

        .financial-item {
          background: white;
          padding: 15px;
          border-radius: 6px;
          border-left: 4px solid #0e6a36;
        }
        
        @media print {
          body { margin: 0; }
          .section { break-inside: avoid; }
          .stats { grid-template-columns: repeat(2, 1fr); }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Event Management Report1</h1>
        <p>Generated on: ${currentDate}</p>
      </div>
      
      <div class="stats-container">
        <div class="stats">
          
          <div class="stat-box">
            <h3>Total Guests</h3>
            <p>${stats?.totalGuests || 0}</p>
          </div>
          <div class="stat-box">
            <h3>Accepted</h3>
            <p>${acceptedGuests?.length || 0}</p>
          </div>
          <div class="stat-box">
            <h3>Declined</h3>
            <p>${declinedGuests?.length || 0}</p>
          </div>
          <div class="stat-box">
            <h3>Refund Requests</h3>
            <p>${stats?.refundRequests || 0}</p>
          </div>
          <div class="stat-box">
            <h3>Total Revenue</h3>
            <p class="currency">${formatCurrency(
              totalRevenue,
              event?.preferredCurrency
            )}</p>
          </div>
        </div>
      </div>

      <!-- Financial Summary Section -->
      <div class="section">
        <h2 class="section-title">Financial Summary</h2>
        <div class="financial-summary">
          <div class="financial-grid">
            <div class="financial-item">
              <span class="event-detail-label">Cash Gifts</span>
              <span class="event-detail-value currency">${formatCurrency(
                totalCashGifts,
                event.preferredCurrency
              )}</span>
            </div>
            <div class="financial-item">
              <span class="event-detail-label">Event Attire Sales</span>
              <span class="event-detail-value currency">${formatCurrency(
                totalEventAttire,
                event.preferredCurrency
              )}</span>
            </div>
            <div class="financial-item">
              <span class="event-detail-label">Ticket Sales</span>
              <span class="event-detail-value currency">${formatCurrency(
                totalTickets,
                event.preferredCurrency
              )}</span>
            </div>
            <div class="financial-item">
              <span class="event-detail-label">Total Revenue</span>
              <span class="event-detail-value currency">${formatCurrency(
                totalRevenue,
                event.preferredCurrency
              )}</span>
            </div>
            <div class="financial-item">
              <span class="event-detail-label">Pending Refunds</span>
              <span class="event-detail-value currency">${formatCurrency(
                pendingRefundAmount,
                event.preferredCurrency
              )}</span>
            </div>
            <div class="financial-item">
              <span class="event-detail-label">Approved Refunds</span>
              <span class="event-detail-value currency">${formatCurrency(
                approvedRefundAmount,
                event.preferredCurrency
              )}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- About Event Section -->
      <div class="section">
        <h2 class="section-title">Event Overview</h2>
        <div class="about-event">
          <h3>${event?.eventTitle || "Untitled Event"}</h3>
          <div class="event-details">
            <div class="event-detail-item">
              <span class="event-detail-label">Event Type</span>
              <span class="event-detail-value">${
                event?.eventType || "Others"
              }</span>
            </div>
            
            <div class="event-detail-item">
              <span class="event-detail-label">Date</span>
              <span class="event-detail-value">${formatDateWithOrdinal(
                event?.multipleDates?.[0]?.date ||
                  event?.eventDate ||
                  event?.startDate
              )}</span>
            </div>
            <div class="event-detail-item">
              <span class="event-detail-label">Time</span>
              <span class="event-detail-value">${
                event?.eventTime ||
                event?.startTime ||
                event?.multipleDates?.[0]?.time ||
                "Not specified"
              }</span>
            </div>
            <div class="event-detail-item">
              <span class="event-detail-label">Location</span>
              <span class="event-detail-value">${
                event?.eventLandmark ||
                event?.customAddress ||
                event?.eventLocation ||
                event?.multipleDates?.[0]?.landmark ||
                event?.multipleDates?.[0]?.location ||
                "Not specified"
              }</span>
            </div>
            <div class="event-detail-item">
              <span class="event-detail-label">Status</span>
              <span class="event-detail-value">${getEventStatus(
                event?.multipleDates?.[0]?.date ||
                  event?.eventDate ||
                  event?.startDate
              )}</span>
            </div>
            <div class="event-detail-item">
              <span class="event-detail-label">Cash Gift Accepted</span>
              <span class="event-detail-value">${
                event?.isCashGiftAccepted ? "Yes" : "No"
              }</span>
            </div>
            ${
              event?.minCashGift
                ? `
            <div class="event-detail-item">
              <span class="event-detail-label">Minimum Cash Gift</span>
              <span class="event-detail-value currency">${formatCurrency(
                event.minCashGift,
                event.preferredCurrency
              )}</span>
            </div>
            `
                : ""
            }
          </div>
          <div class="event-description">
            <span class="event-detail-label">Description</span>
            <p style="margin-top: 8px; line-height: 1.5;">${
              event?.eventDescription || "No description available."
            }</p>
          </div>
        </div>
      </div>

      <!-- Guest List Section -->
      <div class="section">
        <h2 class="section-title">Accepted Guests (${
          acceptedGuests.length
        } guests)</h2>
        ${
          acceptedGuests.length > 0
            ? `
        <table>
          <thead>
            <tr>
              <th>S/No</th>
              <th>Guest Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Cash Gift</th>
              <th>Event Attire</th>
              <th>Ticket</th>
              <th>Delivery Address</th>
              <th>Response Status</th>
              <th>Response Date</th>
              <th>Check In Status</th>
              <th>Check In Date & Time</th>
            </tr>
          </thead>
          <tbody>
            ${acceptedGuests
              .map(
                (guest, index) => `
              <tr>
                <td>${index + 1}</td>
                <td><strong>${ guest.guestName || guest.name || "N/A" }</strong></td>
                <td>${guest.email || "N/A"}</td>
                <td>${guest.phone || "N/A"}</td>
                <td class="currency">${formatCurrency(
                  guest.cashGiftAmount || 0,
                  event.preferredCurrency
                )}</td>
                <td class="currency">${
                  guest.eventAttire === 0
                    ? "0.00"
                    : formatCurrency(
                        guest.eventAttire?.totalAmount || 0,
                        event.preferredCurrency
                      )
                }</td>
                <td class="currency">${
                  guest.ticketFeePaid && guest.ticketFeePaid.length > 0
                    ? formatCurrency(
                        guest.ticketFeePaid[0]?.totalAmount || 0,
                        event.preferredCurrency
                      )
                    : "0.00"
                }</td>
                <td>${guest.deliveryAddress || "N/A"}</td>
                <td>${responseStatus}</td>
                <td>${formatDate(guest.responseDate) || "N/A"}</td>
               <td>${
                 guest.isCheckedIn && guest.checkInTime
                   ? "Checked-In"
                   : "Not Checked-In"
               }</td>  
                <td>${formatDateTime(guest.checkInTime) || "N/A"}</td>

              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>`
            : '<div class="no-data">No guests have accepted the invitation yet.</div>'
        }
      </div>


      <!-- Usher List Section -->
      <div class="section">
        <h2 class="section-title">
          Ushers (${validUshers?.length})
        </h2>

       ${
    validUshers?.length > 0
      ? `
    <table>
      <thead>
        <tr>
        <th>S/No</th>
          <th>Usher Name</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Approval Date</th>
          <th>Approval Status</th>
          <th>Guests Checked In</th>
        </tr>
      </thead>
      <tbody>
        ${validUshers
          .map((usher, index) => {

            const fullName =
              [usher.lastName, usher.firstName].filter(Boolean).join(" ") ||
              "N/A";

            const rawStatus =
              typeof usher.approvalStatus === "string"
                ? usher.approvalStatus
                : "pending";

            const approvalStatus =
              rawStatus.charAt(0).toUpperCase() +
              rawStatus.slice(1).toLowerCase();

            return `
              <tr>
              <td>${index + 1}</td>
                <td><strong>${fullName}</strong></td>
                <td>${usher.email || "-"}</td>
                <td>${usher.phoneNumber || "-"}</td>
                <td>${formatDate(usher.assignedDate) || "-"}</td>
                <td>${approvalStatus}</td>
                <td>${usher.checkedInGuests.length ?? 0}</td>
              </tr>
            `;
          })
          .join("")}
      </tbody>
    </table>
    `
      : `
    <div class="no-data">
      No ushers have been assigned or approved yet.
    </div>
    `
  }
</div>


      <!-- Declined Invites Section -->
      <div class="section">
        <h2 class="section-title">Declined Invites (${
          declinedGuests.length
        } declines)</h2>
        ${
          declinedGuests.length > 0
            ? `
        <table>
          <thead>
            <tr>
              <th>S/No</th>
              <th>Guest Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Response Date</th>
            </tr>
          </thead>
          <tbody>
            ${declinedGuests
              .map(
                (guest, index) => `
              <tr>
              <td>${index + 1}</td>
                <td><strong>${
                  guest.guestName || guest.name || "N/A"
                }</strong></td>
                <td>${guest.email || "N/A"}</td>
                <td>${guest.phone || "N/A"}</td>
                <td>${formatDate(guest.responseDate) || "N/A"}</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>`
            : '<div class="no-data">No declined invitations.</div>'
        }
      </div>

  <!-- Refund Requests Section -->
<div class="section">
  <h2 class="section-title">
   Attire Refund Requests (${validRefunds.length} requests)
  </h2>

  ${
    validRefunds.length > 0
      ? `
    <table>
      <thead>
        <tr>
          <th>S/No</th>  
          <th>Request By</th>
          <th>Email</th>
          <th>Phone Number</th>
          <th>Request Type</th>
          <th>Refund Item</th>
          <th>Amount</th>
          <th>Request Date</th>
          <th>Response Date</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        ${validRefunds
          .map((refund, index) => {
            const guest = refund.guestDetails || {};

            const fullName =
              [guest.firstName, guest.lastName].filter(Boolean).join(" ") ||
              "N/A";

            const amountToRefund =
              refund.refundDetails.eventAttire?.reduce(
                (sum, item) => sum + (item.amountToRefund || 0),
                0
              ) || 0;

            const status = refund?.refundDetails?.refundStatus || "pending";
            const statusClass = status.toLowerCase();

            const requestDate =refund.refundDetails.requestDate;
            const responseDate =refund.refundDetails.responseDate;


            return `
              <tr>
                <td>${index + 1}</td>
                <td><strong>${fullName}</strong></td>
                <td>${guest.email || "N/A"}</td>
                <td>${guest.phoneNumber || "N/A"}</td>
                <td>Refund</td>
                <td>Event Attire</td>
                <td class="currency">
                  ${formatCurrency(
                    amountToRefund,
                    refund.currency || event.preferredCurrency
                  )}
                </td>
                <td>${formatDate(requestDate) || "N/A"}</td>
                  <td>${formatDate(responseDate) || "N/A"}</td>
                <td>
                  <span class="status-badge status-${statusClass}">
                    ${status.charAt(0).toUpperCase() + status.slice(1)}
                  </span>
                </td>
              </tr>
            `;
          })
          .join("")}
      </tbody>
    </table>
    `
      : '<div class="no-data">No refund requests.</div>'
  }
</div>

    </body>
    </html>
  `;
};
